import { DbState, defaultDbState } from 'contexts/db-state';
import { createContext } from 'react';
import { AppSetting } from 'services/types';

export type AppSettingContextData = {
    appSettings: DbState<AppSetting>
    isReady: () => boolean
    [key: string]: DbState<any> | (() => boolean)
}

export const defaultAppSettingContextData: AppSettingContextData = { 
    appSettings: defaultDbState<AppSetting>(),
    isReady: () => false
}

export const AppSettingContext = createContext<AppSettingContextData>(defaultAppSettingContextData)